var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root_layout"},[_c('van-loading',{attrs:{"type":"spinner","size":"30px","text-size":"18px"}},[_vm._v(_vm._s(_vm.showText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }